export { default as departmentsReducer } from './departmentsSlice';

export {
  selectActiveDepartments,
  selectAllDepartments,
  selectDepartmentById,
  selectDepartmentsByStatus,
  selectDepartmentsCount,
  selectDepartmentsError,
  selectDepartmentsLoading,
  selectDepartmentsSorted,
  selectSelectedOutletId,
} from './departmentsSelectors';
